/**
 * File: registerServiceWorkerUtils.ts
 * Path: apps/admin/src/shared/utils/registerServiceWorkerUtils.ts
 * Description: Registers /sw.js (apps/admin/public/sw.js): notifications,
 * taps that open the right page, and the offline screen. Production builds
 * only, so the dev server never serves a stale worker.
 */

export const SERVICE_WORKER_URL = "/sw.js";

export const registerServiceWorker = (): void => {
  if (!import.meta.env.PROD || typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(SERVICE_WORKER_URL, { updateViaCache: "none" }).catch((error: unknown) => {
      console.warn("Service worker registration failed", error);
    });
  });
};
